import * as React from 'react';

import { FormField } from 'components/form';
import InputToggles from 'components/inputs/input-toggles/InputToggles';

import { __t, applyTranslations } from 'utils/language';
import { SPECIALIZED_IN_OPTIONS } from 'utils/influencers';
import { isArrayRequired, maxLengthArray } from 'utils/validators';

import './profile-specialization.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-specialization.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_specialization';

const SPECIALIZED_IN_ITEMS = SPECIALIZED_IN_OPTIONS.map(option => ({
  value: option,
  label: __t(`${COMMON_MSG_KEY}.specialized_in.${option}`)
}));

const SPECIALIZED_IN_MAX_LENGTH = 3;

const ProfileSpecialization: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const specializedIn = profile.specializedIn ?? {};
  const specializedInCustom = specializedIn ? specializedIn.custom : [];

  const handleChange = (
    updatedValues: Array<string>
  ): void => {
    onChange({
      specializedIn: {
        ...profile.specializedIn,
        custom: updatedValues
      }
    });
  };

  return (
    <div className="profile-specialization">
      <FormField
        label={__t(`${MSG_KEY}.title`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        showRequiredMark
        className="profile-specialization__field"
        validators={[
          isArrayRequired(specializedInCustom),
          maxLengthArray(specializedInCustom, SPECIALIZED_IN_MAX_LENGTH)
        ]}
      >
        <div className="profile-specialization__subtitle">
          {__t(`${MSG_KEY}.subtitle`)}
        </div>
        <InputToggles
          items={SPECIALIZED_IN_ITEMS}
          value={specializedInCustom || []}
          limit={SPECIALIZED_IN_MAX_LENGTH}
          onChange={handleChange}
        />
      </FormField>
    </div>
  );
};

export default ProfileSpecialization;
